import { clone_deep } from '@/utils';
import { Mutations } from 'vuex-smart-module';
import { Staffs } from '../../../types';
import StaffDetailState from './state';

export default class StaffDetailMutations extends Mutations<StaffDetailState> {
  SET_CURRENT_STAFF(staff: Staffs.Staff) {
    this.state.current_staff = staff;
  }

  UPD_CURRENT_STAFF_FIELD({ key, value }: { key: keyof Staffs.Staff, value: unknown }) {
    this.state.current_staff[key] = value;
  }

  RESET_EDITABLE_STAFF() {
    this.state.editable_staff = clone_deep(this.state.current_staff);
  }

  UPD_EDITABLE_FIELD({ key, value }: { key: keyof Staffs.Staff, value: unknown }) {
    this.state.editable_staff[key] = value;
  }

  UPD_EDITABLE_PERMISSION({ value, id }: { value: boolean, id: number }) {
    const item = this.state.editable_staff.permissions?.find((item) => item.id === id);

    if (item) {
      item.is_allowed = value;
    }
  }

  CLEAR_ROLES() {
    this.state.editable_staff.roles = [];
    this.state.current_staff.roles = [];
  }

  SET_COMPATIBLE_ROLES(roles: Staffs.CompatibleRoles[]) {
    this.state.compatible_roles = roles;
  }

  CLEAR_COMPATIBLE_ROLES() {
    this.state.compatible_roles = [];
  }

  UPD_FILTER_KEY(value: unknown) {
    this.state.filters.roles = value;
  }

  TOGGLE_ROLES_LOADING(value: boolean) {
    this.state.roles_loading = value;
  }

  CLEAR_FILTER_KEY() {
    this.state.filters.roles = [];
  }
}
